<template>
    <v-container>
        <v-card>
            <v-card-title class="text-h5">Welcome back to the world of Pokémon.</v-card-title>
            <v-divider />
            <v-card-text class="text-body-1 tall">
                Pokémon Mystery Dungeon: Tranquility is a tabletop roleplaying game
                modeled after the Pokémon Mystery Dungeon spinoff series.<br>
                In Tranquility, you play as a Pokémon alongside a team of your
                friends to conquer challenges, protect the innocent, and
                possibly even save the world.
            </v-card-text>
        </v-card>
        <v-card class="mt-8">
            <v-card-title class="text-h5">Choose your own path, and become the very best.</v-card-title>
            <v-divider />
            <v-card-text class="text-body-1 tall">
                The stories told in Tranquility are limited only by your imagination.<br>
                Your Pokémon character's likes, interests, skills, and abilities are yours to choose.<br>
                And, as you play the game and gain more experience, they may even evolve before your eyes.
            </v-card-text>
        </v-card>
        <v-card class="mt-8">
            <v-card-title class="text-h5">Team up with your friends to do amazing things.</v-card-title>
            <v-divider />
            <v-card-text class="text body-1 tall">
                What kind of team will you create?<br>
                All-out offensive?  Support and misdirection? Indomitable defense?  Or, a balance of all three?  Your destiny lies in your own hands.<br>
                Even a Pokémon's Type is more than just strengths and weaknesses.  In Tranquility, typing defines your character to the core.
            </v-card-text>
        </v-card>
        <v-card class="mt-8">
            <v-card-title class="text-h5">As Game Master, create your own world to unfold.</v-card-title>
            <v-divider />
            <v-card-text class="text body-1 tall">
                Tranquility boasts a detailed Game Master's guide to help you create Mystery Dungeons of your own.<br>
                Create and play enemy Pokémon easily without having to worry about bookkeeping.<br>
                Challenge your players, and bring depth to the worlds that they explore.<br>
                And, lastly, thank you.  Without players like you, none of this would be possible.
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
  name: 'About',

  components: {

  },

  data: () => ({

  }),
};
</script>
<style scoped>
    .tall {
        line-height: 2.5 !important
    }
    .v-card__title {
        word-break: normal !important
    }
</style>